import { SetStateAction, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { formatDate } from '../../utils/validator';
import { CustomTable, ErrorModal, Popover, SearchBar, Spinner } from '../../components/shared';
import { truncateString } from '../../utils/utils';
import { allSalonsAPI } from '../../redux/features/salon/salonSlice';
import { allSalonsColumnData, allSalonsTableColumnExtensions } from '../../utils/mockUpData';

const Salons = () => {
  const { loading, error, allSalons } = useAppSelector((state) => state?.allSalons)
  const dispatch = useAppDispatch();

  const rowData =
    allSalons?.data?.map((item: any, index: number) => {
      return {
        index: index + 1,
        id: item?._id,
        salonName: item?.name ? truncateString(item?.name, 3) : "",
        // ownerName: item?.userId?.name ? capitalizeFirstLetter(item?.userId?.name) : "",
        address: item?.address ? truncateString(item?.address, 4) : "",
        city: item?.city ? item?.city : "",
        state: item?.state ? item?.state : "",
        phoneNumber: item?.phoneNumber ? item?.phoneNumber : "",
        zipCode: item?.zipcode ? item?.zipcode : "",
        createdAt: item?.createdAt ? formatDate(item?.createdAt, 'MM/DD/YY, hh:mm A') : "",
      }
    })

  // States
  const [selectedIds, setSelectedIds] = useState([]);
  const [searchName, setSearchName] = useState("");

  // UseEffect
  useEffect(() => {
    dispatch(allSalonsAPI())
  }, [dispatch]);

  return (
    <>
      {loading ?
        <Spinner />
        :
        <div className='w-full h-full flex flex-col gap-2 p-3'>
          <div className='flex gap-2'>
            <SearchBar
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              onClear={() => setSearchName("")}
            />
            <div>
              <Popover menuHeading={'Filters'}>
              </Popover>
            </div>
          </div>

          <ErrorModal
            showModal={Boolean(error)}
            errorMsg={error}
          />

          {/* Table */}
          <div className=''>
            <CustomTable
              rows={rowData?.length > 0 ? rowData : []}
              columns={allSalonsColumnData}
              tableColumnExtensions={allSalonsTableColumnExtensions}
              // dataProviders={dataProviders}
              selectedIds={selectedIds}
              setSelectedIds={(selectedIds: SetStateAction<never[]>) =>
                setSelectedIds(selectedIds)
              }
              componentHeader={true}
            />
          </div>
        </div>
      }
    </>
  );
}

export default Salons;
